import DialogActions from '@material-ui/core/DialogActions';
import DialogTitle from '@material-ui/core/DialogTitle';
import { withStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useStyles } from "../../../assets/jss/DialogFilter";
import { EventTypes, severityLevels, speedSeverityType } from "../../../config/app-globals.enum";
import CustomBox from '../../CustomComponents/CustomBox/CustomBox';
import CustomButton from "../../CustomComponents/CustomButton/CustomButton";
import CustomCheckbox from "../../CustomComponents/CustomCheckbox/CustomCheckbox";
import CustomDialog from "../../CustomComponents/CustomDialog/CustomDialog";
import CustomDialogContent from "../../CustomComponents/CustomDialogContent/CustomDialogContent";
import CustomFormControlLabel from "../../CustomComponents/CustomFormControlLabel/CustomFormControlLabel";
import CustomGrid from '../../CustomComponents/CustomGrid/CustomGrid';
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";


const DialogContent = withStyles((theme) => ({}))(CustomDialogContent);


export default function FilterActionDialog(props) {
    const { t } = useTranslation();
    const classes = useStyles();

    const modalTypesOfEvents = [
        { title: t('SPEEDING'), checked: true, value: EventTypes.SPEEDING },
        { title: t('BRAKING'), checked: true, value: EventTypes.BRAKING },
        { title: t('CORNERING'), checked: true, value: EventTypes.CORNERING },
        { title: t('ACCELERATION'), checked: true, value: EventTypes.ACCELERATION },
        { title: t('DRIVER_DISTRACTION'), checked: true, value: EventTypes.DISTRACTION },
    ]
    const modalSeverityEvents = [
        { title: t('HIGH'), checked: true, value: severityLevels.SEVER },
        { title: t('MEDIUM'), checked: true, value: severityLevels.ALERT },
        { title: t('LOW'), checked: true, value: severityLevels.WARNING },
    ]
    const modalSpeedingEventSeverityTypes = [
        { title: t('MOTORWAY_SPEEDING'), checked: true, value: speedSeverityType.MOTORWAYSPEEDING },// 'isMotorWaySpeeding'
        { title: t('SCHOOL_RUN_SPEEDING'), checked: true, value: speedSeverityType.SCHOOLRUNSPEEDING }, //'isSchoolRunSpeeding' 
        { title: t('DRIVING_BAN'), checked: true, value: speedSeverityType.DRIVINGBAN }, //'isDrivingBan'
    ]

    const resetFilter = () => {
        setmodalTypesOfEventsValues(modalTypesOfEvents);
        setModalSpeedingEventSeverityTypesValues(modalSpeedingEventSeverityTypes);
        setModalSeverityEventsValues(modalSeverityEvents);
    }

    const clearFilter = () => {
        const modalTypesOfEventsClear = [
            { title: t('SPEEDING'), checked: false, value: EventTypes.SPEEDING },
            { title: t('BRAKING'), checked: false, value: EventTypes.BRAKING },
            { title: t('CORNERING'), checked: false, value: EventTypes.CORNERING },
            { title: t('ACCELERATION'), checked: false, value: EventTypes.ACCELERATION },
            { title: t('DRIVER_DISTRACTION'), checked: false, value: EventTypes.DISTRACTION },
        ]
        const modalSeverityEventsClear = [
            { title: t('HIGH'), checked: false, value: severityLevels.SEVER },
            { title: t('MEDIUM'), checked: false, value: severityLevels.ALERT },
            { title: t('LOW'), checked: false, value: severityLevels.WARNING },
        ]
        const modalSpeedingEventSeverityTypesClear = [
            { title: t('MOTORWAY_SPEEDING'), checked: false, value: speedSeverityType.MOTORWAYSPEEDING },// 'isMotorWaySpeeding'
            { title: t('SCHOOL_RUN_SPEEDING'), checked: false, value: speedSeverityType.SCHOOLRUNSPEEDING }, //'isSchoolRunSpeeding' 
            { title: t('DRIVING_BAN'), checked: false, value: speedSeverityType.DRIVINGBAN }, //'isDrivingBan'
        ]
        setmodalTypesOfEventsValues(modalTypesOfEventsClear);
        setModalSpeedingEventSeverityTypesValues(modalSpeedingEventSeverityTypesClear);
        setModalSeverityEventsValues(modalSeverityEventsClear);
    }



    const [open, setOpen] = useState(props.dialogOpen);
    const [modalTypesOfEventsValues, setmodalTypesOfEventsValues] = useState(modalTypesOfEvents);
    const [modalSeverityEventsValues, setModalSeverityEventsValues] = useState(modalSeverityEvents);
    const [modalSpeedingEventSeverityTypesValues, setModalSpeedingEventSeverityTypesValues] = useState(modalSpeedingEventSeverityTypes);
    const [filterEventsValues, setFilterEventsValues] = useState([]);
    const [filterSeverityValues, setFilterSeverityValues] = useState([]);
    const [filterOtherValues, setFilterOtherValues] = useState([]);
    const [isFilterApplied, setIsFilterApplied] = useState(false);

    const handleClose = () => {
        let selectedModalTypesOfEvents = [];
        for (let i = 0; i < modalTypesOfEventsValues.length; i++) {
            const element = modalTypesOfEventsValues[i];
            if (element.checked) {
                selectedModalTypesOfEvents.push(element.value);
            }
        }

        let selectedModalSeverityEvents = [];
        for (let i = 0; i < modalSeverityEventsValues.length; i++) {
            const element = modalSeverityEventsValues[i];
            if (element.checked) {
                selectedModalSeverityEvents.push(element.value);
            }
        }

        let selectedModalSpeedingEventSeverityTypes = [];
        for (let i = 0; i < modalSpeedingEventSeverityTypesValues.length; i++) {
            const element = modalSpeedingEventSeverityTypesValues[i];
            if (element.checked) {
                selectedModalSpeedingEventSeverityTypes.push(element.value);
            }
        }

        props.setSelectedFilters({
            modalTypesOfEvents: selectedModalTypesOfEvents,
            modalSeverityEvents: selectedModalSeverityEvents,
            modalSpeedingEventSeverityTypes: selectedModalSpeedingEventSeverityTypes
        })
        setIsFilterApplied(true);
        props.dialogClose();
    };

    // useEffect(() => {
    //     setOpen(props.dialogOpen);
    //     let selectedFilters = props.selectedFilters;
    //     modalTypesOfEventsValues.map((o) => {
    //         if (selectedFilters.modalTypesOfEvents.includes(o.value)) {
    //             return o.checked = true;
    //         } else {
    //             return o.checked = false;
    //         }
    //     });

    //     modalSeverityEventsValues.map((o) => {
    //         if (selectedFilters.modalSeverityEvents.includes(o.value)) {
    //             return o.checked = true;
    //         } else {
    //             return o.checked = false;
    //         }
    //     });

    //     modalSpeedingEventSeverityTypesValues.map((o) => {
    //         if (selectedFilters.modalSpeedingEventSeverityTypes.includes(o.value)) {
    //             return o.checked = true;
    //         } else {
    //             return o.checked = false;
    //         }
    //     });
    //     setmodalTypesOfEventsValues(modalTypesOfEventsValues);
    //     setModalSeverityEventsValues(modalSeverityEventsValues);
    //     setModalSpeedingEventSeverityTypesValues(modalSpeedingEventSeverityTypesValues);
    // }, [props.dialogOpen]);

    const handleChangeTypesOfEvents = i => e => {
        let arr = [...modalTypesOfEventsValues];
        arr[i].checked = e.target.checked;
        setmodalTypesOfEventsValues(arr);
    };

    const handleChangeSeverityEvents = i => e => {
        let arr = [...modalSeverityEventsValues];
        arr[i].checked = e.target.checked;
        setModalSeverityEventsValues(arr);
    };

    const handleChangeOtherEvents = i => e => {
        let arr = [...modalSpeedingEventSeverityTypesValues];
        arr[i].checked = e.target.checked;
        setModalSpeedingEventSeverityTypesValues(arr);
    };

    const handleCloseBtnClick = () => {
        if (!isFilterApplied) {
            resetFilter();
        }
        props.dialogClose(false)
    };

    const handleClearFilter = () => {
        clearFilter();
    }


    return (
        <CustomDialog maxWidth="md" fullWidth={true} onClose={() => props.dialogClose(false)} aria-labelledby="customized-dialog-title" open={props.dialogOpen} style={{ minWidth: '800px' }}>
            <IconButton aria-label="close" className={classes.filterActionDialogCloseButton} onClick={() => handleCloseBtnClick()} >
                <CloseIcon />
            </IconButton>
            <DialogTitle id="customized-dialog-title">
                <Typography className={classes.headerTitle} >
                    {t('FILTER')}
                </Typography>
            </DialogTitle>
            <DialogContent className={classes.dialogBox}>
                <CustomGrid className={classes.typeRow} container spacing={4} >
                    <CustomGrid item xs={4}>
                        <Typography component="div" className={classes.subTypeTitleLabel}>{t('TYPES_OF_EVENTS')}</Typography>
                        {
                            modalTypesOfEventsValues.map((checkBox, index) => {
                                return (
                                    <React.Fragment key={index}>
                                        <CustomBox className={classes.approveCheckList} >
                                            <CustomFormControlLabel
                                                className={classes.checkboxFormControl}
                                                label={checkBox.title}
                                                control={
                                                    <CustomCheckbox
                                                        color="primary"
                                                        checked={checkBox.checked}
                                                        onChange={handleChangeTypesOfEvents(index)}
                                                        name={checkBox.title}
                                                    />
                                                }
                                            />
                                        </CustomBox>
                                    </React.Fragment>
                                )
                            })
                        }
                    </CustomGrid>
                    {/* <CustomBox>
                        <CustomDivider className={classes.divider} orientation="vertical" />
                    </CustomBox> */}

                    <CustomGrid item xs={4} className={classes.typeBox}>
                        <Typography component="div" className={classes.subTypeTitleLabel}>{t('SEVERITY')}</Typography>
                        {
                            modalSeverityEventsValues.map((checkBox, i) => {
                                return (
                                    <React.Fragment key={i}>
                                        <CustomBox className={classes.approveCheckList} >
                                            <CustomFormControlLabel
                                                className={classes.checkboxFormControl}
                                                label={checkBox.title}
                                                control={
                                                    <CustomCheckbox
                                                        color="primary"
                                                        checked={checkBox.checked}
                                                        onChange={handleChangeSeverityEvents(i)}
                                                        name={checkBox.title}
                                                    />
                                                }
                                            />
                                        </CustomBox>
                                    </React.Fragment>
                                )
                            })
                        }
                    </CustomGrid>
                    {/* <CustomBox>
                        <CustomDivider className={classes.divider} orientation="vertical" />
                    </CustomBox> */}

                    <CustomGrid item xs={4} className={classes.typeBox}>
                        <Typography component="div" className={classes.subTypeTitleLabel}>{t('OTHER')}</Typography>
                        {
                            modalSpeedingEventSeverityTypesValues.map((checkBox, i) => {
                                return (
                                    <React.Fragment key={i}>
                                        <CustomBox className={classes.approveCheckList} >
                                            <CustomFormControlLabel
                                                className={classes.checkboxFormControl}
                                                label={checkBox.title}
                                                control={
                                                    <CustomCheckbox
                                                        color="primary"
                                                        checked={checkBox.checked}
                                                        onChange={handleChangeOtherEvents(i)}
                                                        name={checkBox.title}
                                                    />
                                                }
                                            />
                                        </CustomBox>
                                    </React.Fragment>
                                )
                            })
                        }
                    </CustomGrid>
                </CustomGrid>
            </DialogContent>

            <DialogActions className={classes.dialogActionBox}>
                <Typography component="div" className={classes.clearAll} onClick={() => handleClearFilter()}>{t('CLEAR_ALL')}</Typography>
                <CustomButton className={classes.deleteView} autoFocus onClick={() => handleClose()} variant="contained" color="primary" defaultrounded="true" >
                    {t("APPLY")}
                </CustomButton>
            </DialogActions>
        </CustomDialog>
    );
}
